import React from "react";
import {
  Button,
  Paragraph,
  Modal,
  ModalContent,
  ModalFooterButtons,
} from "@reside/ui";
import {getWorkflowLabel} from "../../../start-workflow/workflowMapping";

type Props = Readonly<{
  residentFirstName: string;
  residentLastName: string;
  isOpen: boolean;
  isLoading: boolean;
  onRequestClose: () => void;
  onSubmit: () => void;
  workflowType: string;
}>;

export const ReturnToResidentModal = ({
  residentFirstName,
  residentLastName,
  isOpen,
  isLoading,
  onRequestClose,
  onSubmit,
  workflowType,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    ariaHideApp={false}
    title={`Return ${getWorkflowLabel(
      workflowType,
    )} to ${residentFirstName} ${residentLastName}`}
  >
    {({closeModal}) => (
      <>
        <ModalContent>
          <Paragraph>
            Do you really wish to return this {getWorkflowLabel(workflowType)}?
            The resident or representative must sign the{" "}
            {getWorkflowLabel(workflowType)} after it is returned.
          </Paragraph>
        </ModalContent>
        <ModalFooterButtons>
          <Button
            outline
            color="primary"
            disabled={isLoading}
            onClick={closeModal}
            testId="cancelReturnToResidentButton"
          >
            Cancel
          </Button>
          <Button
            testId="submitReturnToResidentButton"
            color="danger"
            type="submit"
            disabled={isLoading}
            onClick={onSubmit}
          >
            {isLoading ? "Returning to Resident..." : "Return to Resident"}
          </Button>
        </ModalFooterButtons>
      </>
    )}
  </Modal>
);
